const Filter = ({ ...props }) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.688 8.5H12V6.937A.935.935 0 0 0 11.062 6H9.188a.935.935 0 0 0-.938.938V8.5H2.312A.313.313 0 0 0 2 8.813v.624c0 .172.14.313.313.313H8.25v1.563c0 .519.418.937.938.937h1.874c.52 0 .938-.418.938-.938V9.75h9.688c.171 0 .312-.14.312-.313v-.624a.313.313 0 0 0-.313-.313ZM10.75 11H9.5V7.25h1.25V11Zm10.938 3.125H18.25v-1.563a.935.935 0 0 0-.938-.937h-1.875a.935.935 0 0 0-.937.938v1.562H2.312a.313.313 0 0 0-.312.313v.624c0 .172.14.313.313.313H14.5v1.563c0 .519.418.937.938.937h1.874c.52 0 .938-.418.938-.938v-1.562h3.438c.171 0 .312-.14.312-.313v-.624a.313.313 0 0 0-.313-.313ZM17 16.625h-1.25v-3.75H17v3.75Z"
      fill="#646464"
    />
  </svg>
)

export default Filter
